export const userDetailsInitialState = {
  id: '',
  fullName: '',
  phone: '',
  createdAt: '',
};
